<div [id]="idModal" class="send-email-modal modal fade modal-full-width modal-full-height" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="email">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="to" class="col-form-label">Para</label>
                                <sgt-tokenfield
                                    [(ngModel)]="email.to"
                                    name="to"
                                    id="to"
                                    [createTokensOnBlur]="true"
                                    inputType="email"
                                    tokenDuplicateMessage='E-mail do destinatário já adicionado'
                                    [validateEmail]="true"
                                    required="required"
                                    #to="ngModel"
                                    #toTokenfield
                                    [ngControl]="to"
                                    [inputGroup]="true"
                                    inputGroupIcon="far fa-envelope">
                                </sgt-tokenfield>
                                <sgt-form-control-error
                                    *ngIf="to.errors && to.errors.required && to.dirty"
                                    msgError="É necessário informar o(s) destinatário(s) do e-mail">
                                </sgt-form-control-error>

                                <!-- Emails Administrativos -->
                                <sgt-usuario-email-administrativo-select
                                    (toggleSelect)="onToggleSelectUsuarioEmailAdministrativo($event)"
                                    #usuarioEmailAdministrativoSelect>
                                </sgt-usuario-email-administrativo-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="cc" class="col-form-label">Cc</label>
                                <sgt-tokenfield
                                    [(ngModel)]="email.cc"
                                    name="cc"
                                    id="cc"
                                    [createTokensOnBlur]="true"
                                    inputType="email"
                                    tokenDuplicateMessage='E-mail "com cópia" já adicionado'
                                    [validateEmail]="true"
                                    #cc="ngModel"
                                    [ngControl]="cc"
                                    [inputGroup]="true"
                                    inputGroupIcon="far fa-envelope">
                                </sgt-tokenfield>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="subject" class="col-form-label">Assunto</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="far fa-comment-dots"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control" [(ngModel)]="email.subject" name="subject" id="subject"
                                        #subject="ngModel" #inputSubject required="required">
                                </div>
                                <sgt-form-control-error
                                    *ngIf="subject.errors && subject.errors.required && subject.dirty"
                                    msgError="É necessário informar o assunto do e-mail">
                                </sgt-form-control-error>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="message" class="col-form-label">Mensagem</label>
                                <sgt-rich-text-editor
                                  [(ngModel)]="email.message"
                                  name="message"
                                  id="message"
                                  #message="ngModel"
                                  [control]="message.control"
                                  required>
                                </sgt-rich-text-editor>
                                <sgt-form-control-error
                                    *ngIf="message.errors && message.errors.required && message.dirty"
                                    msgError="A mensagem é obrigatória">
                                </sgt-form-control-error>
                            </div>
                        </div>
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="send()" id="btnSendEmail" [disabled]="form.invalid">
                    <i class="far fa-paper-plane"></i> Enviar
                </button>
            </div>
        </div>
    </div>
</div>
